import React from 'react';
import ReactDOM from 'react-dom';
import MyApp from './MyApp';
import { AuthProvider } from './AuthProvider';

ReactDOM.render(
<AuthProvider>
        {<MyApp/>}
</AuthProvider>,document.getElementById('root'));